var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyreply-message-grid"},_vm._l((_vm.message.data.content[0].images),function(item,index){return _c('div',{key:index,staticClass:"keyreply-grid-item",style:(_vm.gridItemStyle)},[_c('div',{style:({ backgroundImage: `url(${item})` }),on:{"click":function($event){return _vm.$emit('setLightBoxImage', item)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }